export function isProSubscription(plan) {
  return String(plan || '').trim().toLowerCase() === 'pro';
}

export function normalizeSubscriptionPlan(plan) {
  return isProSubscription(plan) ? 'Pro' : 'Starter';
}

export function normalizeWhatsAppNumber(input) {
  if (!input || typeof input !== 'string') return null;

  const trimmed = input.trim();
  if (!trimmed) return null;

  const waMeMatch = trimmed.match(/wa\.me\/(\d+)/i);
  if (waMeMatch) return waMeMatch[1];

  const digits = trimmed.replace(/\D/g, '');
  if (digits.length < 8 || digits.length > 15) return null;

  return digits;
}

export function validateWhatsAppNumber(input, { required = false } = {}) {
  if (!input || !String(input).trim()) {
    if (required) {
      return { valid: false, message: 'WhatsApp number is required for Pro plan' };
    }
    return { valid: true, number: '' };
  }

  const number = normalizeWhatsAppNumber(String(input));
  if (!number) {
    return {
      valid: false,
      message: 'Invalid WhatsApp number. Use international format e.g. +962790000000',
    };
  }

  return { valid: true, number };
}

export function getCartTotal(cart) {
  return cart.reduce((sum, item) => {
    const price = parseFloat(item.price) || 0;
    return sum + price * item.quantity;
  }, 0);
}

export function buildWhatsAppOrderMessage({ restaurant, cart, generalNote, language }) {
  const isAr = language === 'ar';
  const restaurantName =
    isAr && restaurant.resturentNameAr
      ? restaurant.resturentNameAr
      : restaurant.resturentName;
  const currency = restaurant.currency ? `${restaurant.currency} ` : '';
  const total = getCartTotal(cart);
  const lines = [];

  if (isAr) {
    lines.push(`🍽 *طلب جديد - ${restaurantName}*`, '');
    cart.forEach((item) => {
      const name = isAr && item.nameAr ? item.nameAr : item.name;
      const lineTotal = (parseFloat(item.price) || 0) * item.quantity;
      lines.push(`• ${name} × ${item.quantity} - ${currency}${lineTotal.toFixed(2)}`);
      if (item.note?.trim()) {
        lines.push(`  📝 ${item.note.trim()}`);
      }
    });
    lines.push('', `*المجموع: ${currency}${total.toFixed(2)}*`);
    if (generalNote?.trim()) {
      lines.push('', `💬 ملاحظة العميل: ${generalNote.trim()}`);
    }
  } else {
    lines.push(`🍽 *New Order - ${restaurantName}*`, '');
    cart.forEach((item) => {
      const name = item.name;
      const lineTotal = (parseFloat(item.price) || 0) * item.quantity;
      lines.push(`• ${name} x${item.quantity} - ${currency}${lineTotal.toFixed(2)}`);
      if (item.note?.trim()) {
        lines.push(`  📝 ${item.note.trim()}`);
      }
    });
    lines.push('', `*Total: ${currency}${total.toFixed(2)}*`);
    if (generalNote?.trim()) {
      lines.push('', `💬 Customer note: ${generalNote.trim()}`);
    }
  }

  return lines.join('\n');
}

export function openWhatsAppOrder({ restaurant, cart, generalNote, language }) {
  const phone =
    normalizeWhatsAppNumber(restaurant.whatsappNumber) ||
    normalizeWhatsAppNumber(restaurant.whatsappLink);

  if (!phone) {
    return { success: false, message: 'Restaurant WhatsApp number is not configured' };
  }

  if (!cart.length) {
    return { success: false, message: 'Cart is empty' };
  }

  const message = buildWhatsAppOrderMessage({ restaurant, cart, generalNote, language });
  const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
  window.open(url, '_blank');
  return { success: true };
}
